module.exports = "/_next/static/images/d4c9593cc0dd7db89e7693505acaad61-nubanker-pm@3x.jpg.webp";